import React from "react";
import { convertChildrenToData } from './utils';
export function transformData(data, labelKey, valueKey) {
  if (!data) {
    return [];
  }
  return data.map(function (item) {
    if (typeof item === 'string') {
      var _ref;
      return _ref = {}, _ref[valueKey] = item, _ref[labelKey] = item, _ref;
    }
    if (typeof item === 'object') {
      return item;
    }
  });
}
export default function useOptions(data, children, childrenKey, valueKey, labelKey, disabledItemValues) {
  if (disabledItemValues === void 0) {
    disabledItemValues = [];
  }
  return React.useMemo(function () {
    var mergedItems = transformData(data, labelKey, valueKey);
    var childrenAsData = !data;
    if (childrenAsData) {
      mergedItems = convertChildrenToData(children, childrenKey);
    }
    var flattenItems = [];
    var itemValues = [];
    function dig(items, isChildren) {
      if (isChildren === void 0) {
        isChildren = false;
      }
      for (var i = 0; i < items.length; i += 1) {
        var item = items[i];
        if (!item[childrenKey]) {
          if (disabledItemValues.includes(item[valueKey])) {
            item.disabled = true;
          }
          flattenItems.push(item);
          itemValues.push(item[valueKey]);
        } else {
          item.isGroup = true;
          dig(item[childrenKey], true);
        }
      }
    }
    dig(mergedItems);
    return {
      itemValues: itemValues,
      mergedItems: mergedItems,
      flattenItems: flattenItems
    };
  }, [data, children, childrenKey, valueKey]);
}